// extracted by mini-css-extract-plugin
export default {"kidBck":"kidLove_kidBck__KJR7f","kidSwiper":"kidLove_kidSwiper__8-SVQ","bamboBck":"kidLove_bamboBck__kCuPp","snowbck":"kidLove_snowbck__Q8OSh","mobBox":"kidLove_mobBox__u-nt2"};